module.exports = __webpack_public_path__ + "img/icon-noupdates.452b644b.svg";